import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { BackOfficeRfidBadgeOrderModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/rfid-badge-orders/back-office-rfid-badge-order.model';
import { CellContext } from '@tanstack/react-table';

export interface EmspBoRfidBadgeOrderListEmspUserLastNameCellProps
  extends CellContext<
    BackOfficeRfidBadgeOrderModel,
    BackOfficeRfidBadgeOrderModel['emspUser']['lastName']
  > {}

export const EmspBoRfidBadgeOrderListEmspUserLastNameCell = (
  props: EmspBoRfidBadgeOrderListEmspUserLastNameCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return <Text truncate>{getValue() ?? '-'}</Text>;
};
